import { createFileRoute } from '@tanstack/react-router'
import { FleetAccessGovernance } from '@/features/access-governance'

export const Route = createFileRoute('/_authenticated/access-governance/')({
  component: FleetAccessGovernance,
})
